import { Grid, Typography } from '@mui/material';
import { treeMapContainerStyle } from 'views/FleetOverview/components/styles';
import { Treemap, Tooltip } from 'recharts';
import { Base } from 'components/Containers/BaseContainer';
import { ThemePalette } from 'mui.theme';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface TreeNode {
  name: string;
  children?: TreeNode[]; // Children can be an array of TreeNode
  size?: number;
}

export const TreemapSection = ({
  dataTreeMap,
  enableDarkTheme,
  handleFilterUpdate,
  isProductivity,
}: {
  dataTreeMap: TreeNode[];
  enableDarkTheme: boolean;
  handleFilterUpdate: any;
  isProductivity: boolean;
}) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const { t } = useTranslation();
  return (
    <Grid item lg={10} md={12} sm={12} xs={12}>
      <Base
        sx={{
          ...treeMapContainerStyle,
          width: window.innerWidth * 0.65,
          overflow: 'hidden',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: enableDarkTheme
            ? palette.modalBackground
            : '#FFFFFF',
        }}
      >
        <Typography
          sx={{
            paddingTop: '10px',
            paddingBottom: '10px',
            fontSize: '19px',
            fontWeight: '600',
            color: palette.textPrimary,
          }}
        >
          {isProductivity ? 'Production' : 'Idling'}
        </Typography>
        <Treemap
          width={window.innerWidth * 0.65}
          fill="#4A7BFA"
          stroke="white"
          aspectRatio={2 / 1}
          height={(window.outerHeight * 29) / 100}
          data={dataTreeMap}
          dataKey="size"
          onClick={(e) => {
            handleFilterUpdate(e);
          }}
        >
          <Tooltip
            content={({ payload }) => {
              if (payload && payload.length > 0) {
                const { name, value } = payload[0].payload;
                return (
                  <div
                    style={{
                      backgroundColor: '#fee',
                      padding: '6px',
                      border: '1px solid #ccc',
                    }}
                  >
                    <p style={{ fontSize: 'smaller' }}>
                      {t('asset_name')} <b>{name}</b>
                    </p>
                    <p style={{ fontSize: 'smaller' }}>
                      {isProductivity ? 'Production Time' : 'Idling time'}:{' '}
                      <b>{value}</b> hrs
                    </p>
                  </div>
                );
              }
              return null;
            }}
          />
        </Treemap>
      </Base>
      {isProductivity ? (
        <></>
      ) : (
        <span
          style={{
            paddingRight: '10px',
            position: 'relative',
            fontSize: 'smaller',
            color: palette.textPrimary,
          }}
        >
          {t('idle_time_starts_at_6_consecutive_minutes_of_idle_behavior_o')}
        </span>
      )}
    </Grid>
  );
};
